var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M24 0L11 40L24 33.2143L37 40L24 0Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }